<template>
  <div class="viedo_layerpop" v-if="visible">
    <div class="dim">
      <div class="video_content">
        <font-awesome-icon
          class="pointer"
          @click="closeLayer()"
          color="#fff"
          icon="fa-x"
          size="lg"
        />
        <video controls autoplay class="video_player" id="introuduce_video">
          <source
            src="https://kr.object.ncloudstorage.com/web-image/4step_2023ver.mp4"
            type="video/mp4"
          />
        </video>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  watch: {},
  methods: {
    closeLayer() {
      this.$emit("closeLayer", false);
    },
  },
};
</script>

<style>
.viedo_layerpop {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 999;
  display: block;
}

.dim {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}
.video_content {
  width: 50%;
  padding-top: 7%;
  margin: 0 auto;
  text-align: right;
}

.video_player {
  margin: 0 auto;
  width: 100%;
}

/* 767px 이하 */
@media only screen and (max-width: 767px) {
  .video_content {
    width: 95%;
    padding-top: 90%;
  }
}
</style>
